export const GENERA_LOGO = '/img/icons/genera.png';
export const GENERA_LOGO_ALT = 'Logo de Genera';
